import { useTranslation } from "react-i18next";
import { Billing as BillingFeature } from "@/partner/features/billing";
import { Meta } from "@/shared/components";

export function BillingPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("billing.pageTitle")} pageType="Partner" />
      <BillingFeature />
    </>
  );
}
